export default "__VITE_ASSET__4dkXm6hl__"